import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { PERIODS_OPERATION_TYPES, summarizeSubtractPeriodValues } from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetTotalLiabilitiesEquityCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [totalLiabilitiesEquityFiled] = observedFields.totalLiabilitiesEquity.setCalculatedValueFieldNames;

  const getTotalLiabilitiesEquityCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const liabilitiesEquityTotal = summarizeSubtractPeriodValues(content, PERIODS_OPERATION_TYPES.ADD);

        setValue(totalLiabilitiesEquityFiled, liabilitiesEquityTotal);
      }, 500),
     
    [],
  );

  return getTotalLiabilitiesEquityCalculationHandler;
};
